export default {
  'pages.layouts.userLayout.title':
    'Ant Design é a especificação de web design mais influente no distrito de Xihu',
  'pages.login.accountLogin.tab': 'Login da conta',
  'pages.login.accountLogin.errorMessage': 'usuário/senha incorreto(admin/ant.design)',
  'pages.login.failure': 'Login falhou, por favor tente novamente!',
  'pages.login.success': 'Login efetuado com sucesso!',
  'pages.login.username.placeholder': 'Usuário: admin or user',
  'pages.login.username.required': 'Por favor insira seu usuário!',
  'pages.login.password.placeholder': 'Senha: ant.design',
  'pages.login.password.required': 'Por favor insira sua senha!',
  'pages.login.phoneLogin.tab': 'Login com Telefone',
  'pages.login.phoneLogin.errorMessage': 'Erro de Código de Verificação',
  'pages.login.phoneNumber.placeholder': 'Telefone',
  'pages.login.phoneNumber.required': 'Por favor entre com seu telefone!',
  'pages.login.phoneNumber.invalid': 'Telefone é inválido!',
  'pages.login.captcha.placeholder': 'Código de Verificação',
  'pages.login.captcha.required': 'Por favor entre com o código de verificação!',
  'pages.login.phoneLogin.getVerificationCode': 'Obter Código',
  'pages.getCaptchaSecondText': 'seg(s)',
  'pages.login.rememberMe': 'Lembre-me',
  'pages.login.forgotPassword': 'Perdeu a Senha ?',
  'pages.login.submit': 'Enviar',
  'pages.login.loginWith': 'Login com :',
  'pages.login.registerAccount': 'Registra Conta',
  'pages.welcome.link': 'Bem-vindo',
  'pages.welcome.alertMessage': 'Componentes pesados mais rápidos e mais fortes foram lançados.',
  'pages.404.subTitle': 'Desculpe, a página que você visitou não existe. ',
  'pages.404.buttonText': 'Voltar à página inicial',
  'pages.admin.subPage.title': 'Esta página só pode ser vista pelo Admin',
  'pages.admin.subPage.alertMessage':
    'O Umi ui foi lançado, bem-vindo ao usar o npm run ui para iniciar a experiência.',
  'pages.searchTable.createForm.newRule': 'Neva Regra',
  'pages.searchTable.updateForm.ruleConfig': 'Configuração de Regra',
  'pages.searchTable.updateForm.basicConfig': 'Informação básica',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Nome da Regra',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Por favor entre com o nome da regra!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Descrição da Regra',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Por favor insira ao menos cinco caracteres',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Insira uma descrição de regra de pelo menos cinco caracteres!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configurar Propriedades',
  'pages.searchTable.updateForm.object': 'Objeto de Monitoramento',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Modelo de Regra',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Tipo de Regra',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Definir Período de Agendamento',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Hora de Início',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Por favor selecione um horáriod e início!',
  'pages.searchTable.titleDesc': 'Descrição',
  'pages.searchTable.ruleName': 'O nome da regra é obrigatório',
  'pages.searchTable.titleCallNo': 'Número de chamadas de serviço',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'padrão',
  'pages.searchTable.nameStatus.running': 'executando',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'anormal',
  'pages.searchTable.titleUpdatedAt': 'Última programação em',
  'pages.searchTable.exception': 'Por favor, indique o motivo da exceção!',
  'pages.searchTable.titleOption': 'Opção',
  'pages.searchTable.config': 'Configuração',
  'pages.searchTable.subscribeAlert': 'Inscreva-se para receber alertas',
  'pages.searchTable.title': 'Formulário de Consulta',
  'pages.searchTable.new': 'Novo',
  'pages.searchTable.chosen': 'selecionado',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Número total de chamadas de serviço',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'deleção em lote',
  'pages.searchTable.batchApproval': 'aprovação em lote',
  // Site Notice Management
  'pages.siteNoticeManagement.pageTitle': 'Avisos do Site',
  'pages.siteNoticeManagement.noticeList': 'Lista de Avisos',
  'pages.siteNoticeManagement.addNotice': 'Adicionar Aviso',
  'pages.siteNoticeManagement.editNotice': 'Editar Aviso',
  'pages.siteNoticeManagement.deleteNotice': 'Excluir Aviso',
  'pages.siteNoticeManagement.noticeCreated': 'Aviso criado com sucesso!',
  'pages.siteNoticeManagement.noticeUpdated': 'Aviso atualizado com sucesso!',
  'pages.siteNoticeManagement.noticeDeleted': 'Aviso excluído com sucesso!',
  'pages.siteNoticeManagement.operationFailed': 'Operação falhou',
  'pages.siteNoticeManagement.confirmDelete': 'Tem certeza de que deseja excluir este aviso?',
  'pages.siteNoticeManagement.confirmDeleteTitle': 'Excluir Aviso',
  // Site Notice Form Fields
  'pages.siteNoticeManagement.title': 'Título',
  'pages.siteNoticeManagement.titlePlaceholder': 'Digite o título do aviso',
  'pages.siteNoticeManagement.titleRequired': 'Por favor, digite o título do aviso',
  'pages.siteNoticeManagement.content': 'Conteúdo',
  'pages.siteNoticeManagement.contentPlaceholder': 'Digite o conteúdo do aviso',
  'pages.siteNoticeManagement.contentRequired': 'Por favor, digite o conteúdo do aviso',
  'pages.siteNoticeManagement.site': 'Site',
  'pages.siteNoticeManagement.sitePlaceholder': 'Selecione o site',
  'pages.siteNoticeManagement.siteRequired': 'Por favor, selecione um site',
  'pages.siteNoticeManagement.priority': 'Prioridade',
  'pages.siteNoticeManagement.priorityPlaceholder': 'Selecione a prioridade',
  'pages.siteNoticeManagement.priorityLow': 'Baixa',
  'pages.siteNoticeManagement.priorityNormal': 'Normal',
  'pages.siteNoticeManagement.priorityHigh': 'Alta',
  'pages.siteNoticeManagement.priorityUrgent': 'Urgente',
  'pages.siteNoticeManagement.isPublished': 'Publicado',
  'pages.siteNoticeManagement.isActive': 'Ativo',
  'pages.siteNoticeManagement.expiresAt': 'Expira Em',
  'pages.siteNoticeManagement.expiresAtPlaceholder': 'Selecione a data de expiração',
  'pages.siteNoticeManagement.attachments': 'Anexos',
  'pages.siteNoticeManagement.addAttachment': 'Adicionar Anexo',
  'pages.siteNoticeManagement.removeAttachment': 'Remover Anexo',
  'pages.siteNoticeManagement.noAttachments': 'Sem anexos',
  // Site Notice Table Columns
  'pages.siteNoticeManagement.columnTitle': 'Título',
  'pages.siteNoticeManagement.columnSite': 'Site',
  'pages.siteNoticeManagement.columnPriority': 'Prioridade',
  'pages.siteNoticeManagement.columnStatus': 'Status',
  'pages.siteNoticeManagement.columnPublished': 'Publicado',
  'pages.siteNoticeManagement.columnCreatedBy': 'Criado Por',
  'pages.siteNoticeManagement.columnCreatedAt': 'Criado Em',
  'pages.siteNoticeManagement.columnExpiresAt': 'Expira Em',
  'pages.siteNoticeManagement.columnActions': 'Ações',
  // Site Notice Status
  'pages.siteNoticeManagement.statusPublished': 'Publicado',
  'pages.siteNoticeManagement.statusDraft': 'Rascunho',
  'pages.siteNoticeManagement.statusActive': 'Ativo',
  'pages.siteNoticeManagement.statusInactive': 'Inativo',
  'pages.siteNoticeManagement.statusExpired': 'Expirado',
  // Site Notice Priority Colors
  'pages.siteNoticeManagement.priorityColorLow': 'blue',
  'pages.siteNoticeManagement.priorityColorNormal': 'green',
  'pages.siteNoticeManagement.priorityColorHigh': 'orange',
  'pages.siteNoticeManagement.priorityColorUrgent': 'red',

  // Public Holiday Management
  'holidayManagement.title': 'Gerenciamento de Feriados Públicos',
  'holidayManagement.content': 'Gerenciar feriados públicos para sua organização',
  'holidayManagement.holidayList': 'Lista de Feriados',
  'holidayManagement.addNewHoliday': 'Adicionar Novo Feriado',
  'holidayManagement.editHoliday': 'Editar Feriado',
  'holidayManagement.addHoliday': 'Adicionar Feriado',
  'holidayManagement.createSuccess': 'Feriado criado com sucesso',
  'holidayManagement.updateSuccess': 'Feriado atualizado com sucesso',
  'holidayManagement.deleteSuccess': 'Feriado excluído com sucesso',
  'holidayManagement.deleteFailed': 'Falha ao excluir',
  'holidayManagement.operationFailed': 'Operação falhou',
  'holidayManagement.deleteConfirm': 'Tem certeza de que deseja excluir este feriado?',
  'holidayManagement.name': 'Nome do Feriado',
  'holidayManagement.description': 'Descrição',
  'holidayManagement.date': 'Data',
  'holidayManagement.countryCode': 'País',
  'holidayManagement.stateCode': 'Estado/Região',
  'holidayManagement.isNational': 'Feriado Nacional',
  'holidayManagement.status': 'Status',
  'holidayManagement.action': 'Ação',
  'holidayManagement.edit': 'Editar',
  'holidayManagement.delete': 'Excluir',
  'holidayManagement.yes': 'Sim',
  'holidayManagement.no': 'Não',
  'holidayManagement.active': 'Ativo',
  'holidayManagement.inactive': 'Inativo',
  'holidayManagement.searchName': 'Pesquisar nome do feriado',
  'holidayManagement.searchDescription': 'Pesquisar descrição',
  'holidayManagement.holidayName': 'Nome do Feriado',
  'holidayManagement.pleaseEnterHolidayName': 'Por favor, digite o nome do feriado',
  'holidayManagement.pleaseSelectDate': 'Por favor, selecione a data',
  'holidayManagement.pleaseSelectCountry': 'Por favor, selecione o país',
  'holidayManagement.pleaseSelectState': 'Por favor, selecione o estado/região',
  'holidayManagement.isActive': 'Ativo',
  'holidayManagement.showing': 'Mostrando',
  'holidayManagement.of': 'de',
  'holidayManagement.items': 'itens',

  // Nomes dos Feriados Públicos de Hong Kong
  'holidayManagement.holidayNames.newYearsDay': 'Dia de Ano Novo',
  'holidayManagement.holidayNames.lunarNewYearsDay': 'Dia do Ano Novo Lunar',
  'holidayManagement.holidayNames.secondDayOfLunarNewYear': 'Segundo Dia do Ano Novo Lunar',
  'holidayManagement.holidayNames.thirdDayOfLunarNewYear': 'Terceiro Dia do Ano Novo Lunar',
  'holidayManagement.holidayNames.chingMingFestival': 'Festival Ching Ming',
  'holidayManagement.holidayNames.goodFriday': 'Sexta-feira Santa',
  'holidayManagement.holidayNames.dayFollowingGoodFriday': 'Dia seguinte à Sexta-feira Santa',
  'holidayManagement.holidayNames.easterMonday': 'Segunda-feira de Páscoa',
  'holidayManagement.holidayNames.labourDay': 'Dia do Trabalho',
  'holidayManagement.holidayNames.buddhaBirthday': 'Aniversário do Buda',
  'holidayManagement.holidayNames.tuenNgFestival': 'Festival Tuen Ng',
  'holidayManagement.holidayNames.hkEstablishmentDay':
    'Dia do Estabelecimento da Região Administrativa Especial de Hong Kong',
  'holidayManagement.holidayNames.nationalDay': 'Dia Nacional',
  'holidayManagement.holidayNames.dayFollowingMidAutumn':
    'Dia seguinte ao Festival do Meio do Outono Chinês',
  'holidayManagement.holidayNames.chungYeungFestival': 'Festival Chung Yeung',
  'holidayManagement.holidayNames.christmasDay': 'Natal',
  'holidayManagement.holidayNames.firstWeekdayAfterChristmas': 'Primeiro dia útil após o Natal',
  'holidayManagement.quickAddCommonHoliday': 'Adicionar Feriado Comum Rapidamente',
  'holidayManagement.originalName': 'Nome original',
};
